export const editProjectSettingsRoutesName = {
    editProject: "edit-project",
};
